import { Button, ButtonProps, styled } from "@mui/material";
import React from "react";
import { pxToRem } from "../../../platform-style";

const commonBorderRadius = 20;
const LAYOUT_TOGGLE_STORAGE_KEY = "ENABLE_ALTERNATE_LAYOUT";
const useAlternateLayout = localStorage.getItem(LAYOUT_TOGGLE_STORAGE_KEY) === "true";
export const SuggestionButton = styled(Button)<ButtonProps>(({ theme }) =>
  useAlternateLayout
    ? {
        textTransform: "none",
      }
    : {
        backgroundColor: theme.palette.background.paper,
        border: "1px solid",
        borderColor: theme.palette.text.primary,
        borderRadius: `${commonBorderRadius}px`,
        color: theme.palette.text.primary,
        fontSize: pxToRem(15),
        fontWeight: "normal",
        minWidth: "auto",
        margin: pxToRem(3),
        height: pxToRem(40),
        letterSpacing: "normal",
        lineHeight: "unset",
        paddingLeft: pxToRem(20),
        paddingRight: pxToRem(20),
        textTransform: "none",
        ":focus": {
          border: "1px solid",
          borderColor: theme.palette.divider,
          borderRadius: `${commonBorderRadius}px`,
          color: "theme.palette.primary.main",
        },
        ":hover": {
          border: "1px solid",
          borderColor: theme.palette.divider,
          borderRadius: `${commonBorderRadius}px`,
          color: "theme.palette.primary.main",
        },
      }
) as React.ComponentType<ButtonProps>;
